export default __webpack_public_path__ + "static/media/brandontext-regular.8e8ad454.ttf";